(function componentForm($, Adzuki)
{
	'use strict';

	var form = {
		name: 'LivePlannerScheduleAppointment',
	};

	$(document).ready(function onDocumentReady()
	{
		Adzuki.Form.registerForm(form);
	});

	form.load = function load()
	{
		Adzuki.LivePlannerParticipants.init(form.name);

		Adzuki.CharacterCount('#liveplannerscheduleappointment-comments', {
			max  : 255,
			label: '#client-notes-count',
		});
	};

}(jQuery, window.Adzuki || {}));
